import qs from 'qs';

const ProgramStatus = {
    namespaced: true,

    state: {
        programStatusData: [],
    },

    getters: {
        programStatusData (state) {
            return state.programStatusData;
        },
    },

    mutations: {

        /**
         * Установить значение должности
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['programStatusData'] = items;
        },

        /**
         * Обновить значение элемента должности
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['programStatusData'][index] = item;
        },

        /**
         * Добавить значение элемента должности
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['programStatusData'].push(item);
        },

        /**
         * Удалить элемент из должности
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['programStatusData'] = state['programStatusData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по должностям
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getProgramStatusData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl +  'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.programStatus,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по статусам программ получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN programStatus.js | getProgramStatusData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по статусам программ!'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по должностям
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveProgramStatusData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.programStatus,
                    }),
                }).then(response => {
                    console.log(response.data);
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по статусам программ успешно отредактированы!');

                    // Если сохранение нового
                    } else {
                      data.data.programStatusId = response.data[0].programStatusId;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый статус по программе создан!');
                    }
                    resolve();
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN programStatus.js | saveProgramStatusData : ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление должности
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeProgramStatusData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.programStatus,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Должности успешно удалены!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении должности!'),
                    console.log('ERROR IN programStatus.js | removeProgramStatusData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default ProgramStatus;





// WEBPACK FOOTER //
// ./src/store/modules/programStatus.js